define('views/modules/calendar/animated-session/tags/manager/edit/tag-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    // parents views
    'src/views/form-view',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/calendar/animated-session/tags/manager/form/custom-tag-form',
    'views/modules/calendar/animated-session/animation/animation-panel',
    // templates
    'text!templates/modules/calendar/animated-session/tags/edit/tag-edit-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    // parent views
    VForm,
    // views
    VMenuSaveAction,
    VCustomTagForm,
    VAnimationPanel,
    // templates
    TTagEditContent
) {

    var VTagEditContent = VForm.extend({

        template: TTagEditContent,

        regions: {
            root: ".tag-edit-content",
            menu: ".menu-actions",
            form: ".tag-edit-form",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.group = this.options.group;

            var view = this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveButton,
                    saveText: 'Save',
                    collection: new Backbone.Collection([
                        { route: '#', title: 'Add an exercise', itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddExerciseAction },
                    ]),
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                form: new VCustomTagForm({
                    model: this.model,
                })
            };

            this.panel = {};

            this.listenTo(this.model, { 'change': this.onModelChange });
            this.listenTo(view.form, { 'list:addExercise': this.onAddExerciseAction });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form);
        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddExerciseAction: function() {
            this.toggleAnimationPanel(true);
        },

        toggleAnimationPanel: function(val) {
            var view = this.panel,
                animation = view.animation || (view.animation = new VAnimationPanel({ group: this.group }));
            this.trigger('drawer:view', animation, val);
            return this;
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        isDirty: function() {
            return VTagEditContent.__super__.isDirty.call(this) || this.view.form.hasCollectionChanged();
        },

        onSubmit: function() {
            if (this.model.isNew()) {
                this.model.set('group', this.group.id);
            }
            this.view.form.onSubmit();
        },

        onSaveButton: function() {
            this.submit();
        },

        onSuccess: function() {
            this.trigger('form:success', this.model.clone());
        },

    });

    return VTagEditContent;

});

